import { MyClaimsListResponse } from '@/domains/claims/types/responses/getMyClaimsListResponse';
import type { HttpServiceResponse } from '@/services/HttpService/types';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { selectMyClaimsListPagination } from '@/domains/claims/claimsSlice/claimsSelectors';
import { getMyClaimsList, getMyClaimsListSuccess } from '@/domains/claims/claimsSlice/claimsSlice';
import { MY_CLAIMS_TAB_TAG, MY_CLAIMS_TAG } from '@/domains/claims/constants/myClaimsQueryParamTags';
import HttpService from '@/services/HttpService/HttpService';
import QueryParamsService from '@/services/QueryParamsService/QueryParamsService';

function* getMyClaimsListSaga() {
  const { page, perPage } = yield select(selectMyClaimsListPagination);
  const listQueryParams = QueryParamsService.getAllByPrefix(MY_CLAIMS_TAG);

  try {
    const { data }: HttpServiceResponse<MyClaimsListResponse> = yield call(
      HttpService.post,
      `/examiner/claims?claimEndpointType=${listQueryParams[MY_CLAIMS_TAB_TAG]}`,
      {
        page,
        perPage,
        claimMilestones: listQueryParams.claimMilestones?.split(','),
        claimStatuses: listQueryParams.claimStatuses?.split(','),
        claimTags: listQueryParams.claimsTags?.split(','),
        sortBy: listQueryParams.sortBy,
        sortDirection: listQueryParams.sortDirection,
      },
    );

    yield put(getMyClaimsListSuccess(data));
  } catch (error) {
    console.error(error);
  }
}

export function* claimsWatcher() {
  yield takeLatest([getMyClaimsList.type], getMyClaimsListSaga);
}
